import { render, staticRenderFns } from "./CardLeftColl.vue?vue&type=template&id=271ba7a9&scoped=true&"
import script from "./CardLeftColl.vue?vue&type=script&lang=js&"
export * from "./CardLeftColl.vue?vue&type=script&lang=js&"
import style0 from "./CardLeftColl.vue?vue&type=style&index=0&id=271ba7a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271ba7a9",
  null
  
)

export default component.exports